import { IVatTable } from '../ITaxesTable';
import { VatCalculatingError } from '../Errors/VatCalculatingError';
import { CacheKeys } from '../../../../cache/cacheKeys';
import { ITaxLoader } from '../TaxLoader/ITaxLoader';
import { TaxLoaderError } from '../Errors/TaxLoaderError';
import { ITaxes } from '../iTaxes';
import { CacheRepository } from '../../../../cache/iCacheRepository';

export class VatService implements ITaxes {
    private vatTable: IVatTable;
    private storage: CacheRepository;
    private taxLoader: ITaxLoader;

    constructor(localStorage: CacheRepository, taxLoader: ITaxLoader) {
        this.storage = localStorage;
        this.taxLoader = taxLoader;
    }

    public async calculate(revenue: number, country: string): Promise<number> {
        const table = await this.load();
        if (table instanceof VatCalculatingError) {
            window.Sentry.captureException(table.message);
            return 0;
        }

        if (!country) {
            console.error(`VAT country is false ${country}`);
            return 0;
        }

        if (!table.vat_rate[country]) {
            console.error(`VAT country is not exists in a map`, {
                country: country
            });
            return 0;
        }

        console.log('VAT calculating', {
            country: country,
            feeTable: table.vat_rate[country],
            revenue: revenue
        });
        return revenue * table.vat_rate[country];
    }

    private async load(): Promise<IVatTable | VatCalculatingError> {
        const vatTable: IVatTable = this.storage.get<IVatTable>(CacheKeys.VAT);
        console.log('LOAD FROM STORAGE', vatTable);
        if (vatTable && vatTable.vat_rate && this.isValidDate(vatTable.date)) {
            console.log('VAT has loaded from storage');
            return vatTable;
        }

        if (this.vatTable && this.isValidDate(this.vatTable.date)) {
            console.log('VAT has loaded from memory');
            return this.vatTable;
        }

        const actualVatTable = await this.taxLoader.getVat();
        console.log('FEE TABLE', actualVatTable);
        if (actualVatTable instanceof TaxLoaderError) {
            return new VatCalculatingError(actualVatTable.message);
        }
        console.log('VAT has loaded from DE');

        const isItSaved = this.save(actualVatTable);
        if (isItSaved instanceof VatCalculatingError) {
            return isItSaved;
        }

        return actualVatTable;
    }

    private save(table: IVatTable): boolean | VatCalculatingError {
        try {
            this.vatTable = table;
            this.storage.set(CacheKeys.VAT, this.vatTable);
            return true;
        } catch (exception) {
            return new VatCalculatingError(
                exception.message,
                exception.stack
            );
        }
    }

    private isValidDate(date: string): boolean {
        const secInDay = 86400;
        const daysOffset = 30;

        const tableTimestampSec = new Date(date).getTime() / 1000;
        const currentTimestampSec = new Date().getTime() / 1000;
        console.log('Fee data actuality', {
            forUpdate: currentTimestampSec,
            result: tableTimestampSec < currentTimestampSec - daysOffset * secInDay,
            table: tableTimestampSec
        });

        return tableTimestampSec > currentTimestampSec - daysOffset * secInDay;
    }
}
